import type { ExtractAtomValue } from 'jotai';
import { atom } from 'jotai';
import isUndefined from 'lodash/isUndefined';
import { LABELLING_TYPE } from '../../../common/constant/constant';
import type { MetaDataT } from '../../labelling/types';
import { numFramesAtom } from './annotation-atoms';
export const dataUrlAtom = atom<string>();
export const mediaFileRefAtom = atom<string>();
export const metadataAtom = atom<MetaDataT>({
  height: 0,
  width: 0,
  rotation: 0
});
export const fileTypeAtom = atom<typeof LABELLING_TYPE.IMAGE | typeof LABELLING_TYPE.VIDEO | typeof LABELLING_TYPE.PDF>(LABELLING_TYPE.IMAGE);
export const frameRateAtom = atom<number>();
export const isVideoPlayerAtom = atom(get => {
  const frameRate = get(frameRateAtom);
  const numFrames = get(numFramesAtom);
  return !isUndefined(frameRate) && numFrames > 1;
});
export type FileAtomHydrationList = [typeof dataUrlAtom, ExtractAtomValue<typeof dataUrlAtom>] | [typeof mediaFileRefAtom, ExtractAtomValue<typeof mediaFileRefAtom>] | [typeof metadataAtom, ExtractAtomValue<typeof metadataAtom>] | [typeof fileTypeAtom, ExtractAtomValue<typeof fileTypeAtom>] | [typeof frameRateAtom, ExtractAtomValue<typeof frameRateAtom>];